import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';

import { LAYER_SUBTYPES } from '../../../api/Layers/Layers';
import { getInterval } from '../../../api/Layers/layer-operations';

const LayerIntervalField = ({ layer, layerSubType }) => {
  if (
    layerSubType === LAYER_SUBTYPES.REALTIME ||
    layerSubType === LAYER_SUBTYPES.ANNOTATIONSREALTIME
  ) {
    return (
      <Form.Group>
        <Form.Label>Refreshing Time (milliseconds)</Form.Label>
        <Form.Control type="number" name="interval" defaultValue={getInterval(layer)} min="1" />
      </Form.Group>
    );
  }

  return '';
};
LayerIntervalField.propTypes = {
  layer: PropTypes.object.isRequired,
  layerSubType: PropTypes.string.isRequired
};

export default LayerIntervalField;
